import Vue from "vue";
import router from "@/router/index";
import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "UA-139608219-1",
  router,
});
